import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeNumIdentificationNational } from '../models/TypeNumIdentificationNational';
import { Step2 } from '../../../../shared/models/component-messages/blocCommun/simp/step2';
import { RadioCheckBoxEnum } from '../../../common/radio.checkbox.enums';

@Component({
  selector: 'app-type-num-identification-national',
  templateUrl: './type-num-identification-national.component.html'
})
export class TypeNumIdentificationNationalComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeNumIdentificationNational'
  @Input() parentForm: FormGroup;
  @Input() disabled: boolean;
  
  	@Input() typeIdentificationNational : TypeNumIdentificationNational;

    public step2 = new Step2();

    public readonly siretValue = RadioCheckBoxEnum.siretValue;
    public readonly sirenValue = RadioCheckBoxEnum.sirenValue;
    public readonly ridetValue = RadioCheckBoxEnum.ridetValue;
    public readonly tahitiValue = RadioCheckBoxEnum.tahitiValue;
    public readonly frwfValue = RadioCheckBoxEnum.frwfValue;
    public readonly irepValue = RadioCheckBoxEnum.irepValue;
    public readonly tvaIntraValue = RadioCheckBoxEnum.tvaIntraValue;
  
    public radioButtonValue: string;
    public radioButtonCtrlName: string;

  constructor() { }

  public ngOnInit() {
    if(this.typeIdentificationNational?.siret === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.siretValue;
    } else if(this.typeIdentificationNational?.siren === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.sirenValue;
    } else if(this.typeIdentificationNational?.ridet === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.ridetValue;
    } else if(this.typeIdentificationNational?.tahiti === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.tahitiValue;
    } else if(this.typeIdentificationNational?.frwf === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.frwfValue;
    } else if(this.typeIdentificationNational?.irep === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.irepValue;
    } else if(this.typeIdentificationNational?.tvaIntra === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.tvaIntraValue;
    } else {
      this.radioButtonValue = this.siretValue;
    }

    this.radioButtonCtrlName = this.getUid() + '_SepAtt_siret';
  }
  
  
  
  
  
  

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }  
  
  
}

